<template>
  <div class="today-number">
    <div v-if="$store.getters.currentTodayNoCalling == 0">
      <b-button
        id="btn-back"
        variant="link"
        class="po-left"
        v-on:click="serviceToday(0)"
        ><b-img
          class="mr-2"
          :src="path + angle_left_small"
          alt="angle_left_small"
        ></b-img
        >{{ $t("back") }}</b-button
      >
      <div class="text-center">
        <b-img :src="path + today" alt="today"></b-img>
        <p class="text-22 text-muted semi-bold mt-2 mb-0">
          {{ $t("today_title") }}
        </p>
        <p class="text-22 semi-bold">
          {{ $t("put_no_calling") }}
        </p>
      </div>
      <hr />
      <b-form>
        <p
          class="text-14 semi-bold mb-2"
          :class="{
            submiterror:
              (!$v.name.required || !$v.name.minLength || !$v.name.maxLength) &&
              error
          }"
        >
          {{ $t("name_and_surname") }}
          <span class="text-14 text-muted normal"
            >&nbsp;&nbsp;&nbsp;&nbsp;{{ $t("must_be_filled") }}</span
          >
        </p>
        <b-form-input
          id="name"
          type="text"
          v-model.trim.lazy="$v.name.$model"
        ></b-form-input>
        <p class="text-14 text-danger error" v-if="!$v.name.required && error">
          {{ $t("must_be_filled") }}
        </p>
        <p class="text-14 text-danger error" v-if="!$v.name.minLength && error">
          {{ $t("put_min") }}&nbsp;{{ $v.name.$params.minLength.min }}&nbsp;{{
            $t("char")
          }}
        </p>
        <p class="text-14 text-danger error" v-if="!$v.name.maxLength && error">
          {{ $t("put_max") }}&nbsp;{{ $v.name.$params.maxLength.max }}&nbsp;{{
            $t("chars")
          }}
        </p>
        <p
          class="text-14 semi-bold mt-4 mb-2"
          :class="{
            submiterror:
              $v.inr.required &&
              (!$v.inr.minLength || !$v.inr.maxLength) &&
              error
          }"
        >
          {{ $t("your_in") }}
          <span
            v-if="$store.getters.today.personal_data_required"
            class="text-14 text-muted normal"
            >&nbsp;&nbsp;&nbsp;&nbsp;{{ $t("must_be_filled") }}</span
          >
          <span
            v-if="!$store.getters.today.personal_data_required"
            class="text-14 text-muted normal"
            >&nbsp;&nbsp;&nbsp;&nbsp;({{ $t("doesnt_have_be_filled") }})</span
          >
        </p>
        <b-form-input
          id="inr"
          type="text"
          v-model.trim.lazy="$v.inr.$model"
        ></b-form-input>
        <p class="text-14 text-danger error" v-if="!$v.inr.maxLength && error">
          {{ $t("put_max") }}&nbsp;{{ $v.inr.$params.maxLength.max }}&nbsp;{{
            $t("chars")
          }}
        </p>
        <p
          v-if="inrMinLength && $v.inr.required && error"
          class="text-14 text-danger error"
        >
          {{ $t("put_min") }}&nbsp;9&nbsp;{{ $t("numbers") }}
        </p>
        <p
          v-if="inrMaxLength && $v.inr.required && error"
          class="text-14 text-danger error"
        >
          {{ $t("put_max") }}&nbsp;12&nbsp;{{ $t("numbers") }}
        </p>
        <p
          class="text-14 semi-bold mt-4 mb-2"
          :class="{
            submiterror:
              (!$v.message.minLength || !$v.message.maxLength) &&
              $v.inr.required &&
              error
          }"
        >
          {{ $t("message_for_doctor")
          }}<span class="text-14 text-muted normal"
            >&nbsp;&nbsp;&nbsp;&nbsp;({{ $t("doesnt_have_be_filled") }})</span
          >
        </p>
        <b-form-textarea
          id="message"
          type="text"
          rows="2"
          v-model.trim.lazy="$v.message.$model"
        ></b-form-textarea>
        <p class="text-14 text-danger error" v-if="!$v.name.maxLength && error">
          {{ $t("put_max") }}&nbsp;{{ $v.name.$params.maxLength.max }}&nbsp;{{
            $t("chars")
          }}
        </p>
        <div class="text-14 semi-bold text-center mt-5">
          <b-button block size="lg" v-on:click="serviceTodayNoCalling(1)"
            >{{ $t("next")
            }}<b-img
              class="po-right"
              :src="path + angle_right"
              alt="order_recipe"
            ></b-img
          ></b-button>
        </div>
      </b-form>
    </div>
    <div v-if="$store.getters.currentTodayNoCalling == 1" class="text-center">
      <b-button
        id="btn-back"
        variant="link"
        class="po-left"
        v-on:click="serviceTodayNoCalling(0)"
        ><b-img
          class="mr-2"
          :src="path + angle_left_small"
          alt="angle_left_small"
        ></b-img
        >{{ $t("back") }}</b-button
      >
      <div class="text-center">
        <b-img :src="path + today" alt="today"></b-img>
        <p class="text-22 text-muted semi-bold mt-2 mb-0">
          {{ $t("today_title") }}
        </p>
      </div>
      <p class="text-22 semi-bold">
        {{ $t("put_no_calling") }}
      </p>
      <hr />
      <b-card
        border-variant="primary"
        body-bg-variant="primary"
        class="mb-3 info"
      >
        <p class="text-14 text-primary mb-0">
          {{ $t("put") }} {{ $store.getters.today.nextfreenr }}.
        </p>
      </b-card>
      <p class="text-14 semi-bold">
        {{ $t("put_no_calling_send_sms") }}
      </p>
      <Sms></Sms>
      <p class="text-12 semi-bold">
        {{ $t("actual_state_no_calling") }}
      </p>
      <p class="text-12 semi-bold text-danger mb-0">
        {{ $t("actual_state_attention") }}
      </p>
    </div>
    <div v-if="$store.getters.currentTodayNoCalling == 2">
      <div class="text-center">
        <b-img :src="path + today" alt="today"></b-img>
        <p class="text-22 text-muted semi-bold mt-2 mb-0">
          {{ $t("today_title") }}
        </p>
        <p class="text-22 semi-bold">{{ $t("put_no_calling") }}</p>
      </div>
      <b-button
        id="btn-back"
        variant="link"
        class="po-left"
        v-on:click="closeTab"
        ><b-img
          class="mr-2"
          :src="path + angle_left_small"
          alt="angle_left_small"
        ></b-img
        >{{ $t("back") }}</b-button
      >
      <hr />
      <b-card border-variant="primary" body-bg-variant="primary" class="mb-3">
        <p
          v-if="$store.getters.today.entrynote != null"
          class="text-14 text-primary semi-bold mb-0"
        >
          {{ $store.getters.today.entrynote }}
        </p>
        <div class="d-flex justify-content-between mt-2">
          <div class="text-center">
            <p class="text-22 text-secondary bold mb-0">
              {{
                $store.getters.today.currentnr !== null
                  ? $store.getters.today.currentnr
                  : "?"
              }}
            </p>
            <p class="text-12 semi-bold mb-0">
              {{ $t("equipped_number") }}
            </p>
          </div>
          <div class="text-center">
            <p class="text-22 text-secondary bold mb-0">
              {{ $store.getters.today.nextfreenr }}
            </p>
            <p class="text-12 semi-bold mb-0">
              {{ $t("issue_number") }}
            </p>
          </div>
          <div class="text-center">
            <p class="text-22 text-secondary bold mb-0">
              {{ date | moment }}
            </p>
            <p class="text-12 semi-bold mb-0">
              {{ $t("updated") }}
            </p>
          </div>
        </div>
      </b-card>
      <b-card border-variant="primary" body-bg-variant="primary" class="mb-3">
        <p class="text-14 text-center text-primary mb-0">
          {{ $t("ticket_for_today") }}&nbsp;{{
            $store.getters.orderStatus.app_nr
          }}
        </p>
      </b-card>
      <b-button block size="lg" v-on:click="closeTab"
        >{{ $t("to_start")
        }}<b-img
          class="po-right"
          :src="path + angle_right"
          alt="order_recipe"
        ></b-img
      ></b-button>
    </div>
  </div>
</template>

<script>
import config from "../../../../config";
import close from "../../../assets/old/close.svg";
import angle_left_small from "../../../assets/old/angle_left_small.svg";
import angle_right from "../../../assets/old/angle_right.svg";
import info from "../../../assets/old/info.svg";
import oval from "../../../assets/old/oval.svg";
import refresh from "../../../assets/old/refresh.svg";
// import today from "../../../assets/old/today2.svg";

import today from "../../../assets/icons/doors2.svg";

import Sms from "../Sms";
let moment = require("moment");
import Vue from "vue";
import {
  required,
  requiredUnless,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
import VueNativeSock from "vue-native-websocket";
Vue.use(VueNativeSock, config.SOCKET, {
  connectManually: true
});
export default {
  components: {
    Sms
  },
  data() {
    return {
      path: config.URL,
      close: close,
      angle_left_small: angle_left_small,
      angle_right: angle_right,
      info: info,
      oval: oval,
      today: today,
      refresh: refresh,
      numberStyle: {
        background: 'url("' + config.URL + oval + '") no-repeat center'
      },
      date: new Date(),
      name: "",
      inr: "",
      message: "",
      error: false
    };
  },
  computed: {
    getRequired() {
      return this.$store.getters.today.personal_data_required;
    },
    nameMinLength() {
      return this.name.length > 2 ? false : true;
    },
    nameMaxLength() {
      return this.name.length + this.message.length <= 512 ? false : true;
    },
    inrMinLength() {
      return this.inr.replace(/\D/g, "").length > 8 ? false : true;
    },
    inrMaxLength() {
      return this.inr.replace(/\D/g, "").length <= 12 ? false : true;
    }
  },
  validations: {
    name: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(512)
    },
    inr: {
      required: requiredUnless("getRequired"),
      minLength: minLength(9),
      maxLength: maxLength(512)
    },
    message: {
      maxLength: maxLength(512)
    }
  },
  methods: {
    closeTab() {
		this.$router.push({ name: 'home' })
      // this.$store.dispatch("setCurrentService", 0);
      this.$store.dispatch("setCurrentToday", 0);
      this.$store.dispatch("setCurrentTodayNoCalling", 0);
    },
    serviceToday(index) {
      this.$store.dispatch("setCurrentToday", index);
    },
    serviceTodayNoCalling(index) {
      if (index == 1) {
        this.$v.$touch();
        if (
          (this.$v.$invalid &&
            !this.$store.getters.nextDays.personal_data_required &&
            this.$v.name.$error) ||
          (this.inrMinLength && this.$v.inr.required) ||
          (this.inrMinLength && this.inrMaxLength && this.$v.inr.required)
        ) {
          this.error = true;
          let element = document.getElementsByClassName("submiterror");
          this.$nextTick(() => {
            element[0].scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          });
          return false;
        } else {
          this.error = false;
          const message = this.message != "" ? ", " + this.message : "";
          this.$store.dispatch("placeOrder", {
            type: "today",
            infoservice: this.$store.getters.service,
            name: this.name + message,
            pnr: this.inr
          });
          this.$store.dispatch("setCurrentTodayNoCalling", index);
          setTimeout(() => {
            this.$connect(
              config.SOCKET + this.$store.getters.placeOrder.order_key
            );
            this.$options.sockets.onmessage = data => {
              if (JSON.parse(data.data).event == "order_confirmed") {
                this.$store.dispatch("getOrderStatus");
                this.$store.dispatch("setCurrentTodayNoCalling", 2);
              } else if (JSON.parse(data.data).event == "order_paid") {
                this.$store.dispatch("getOrderStatus");
                this.$disconnect();
              } else {
                // console.log('error', JSON.parse(data.data).event)
              }
            };
          }, 5000);
        }
      } else {
        this.$store.dispatch("setCurrentTodayNoCalling", index);
      }
    },
    refreshState() {
      this.$store.dispatch("postToday");
      this.date = new Date();
    }
  },
  filters: {
    moment: date => {
      return moment(date).format("HH:mm:ss");
    }
  },
  watch: {
    "$store.getters.currentTodayNoCalling": function() {
      if (this.$store.getters.currentTodayNoCalling == 1) {
        var that = this;
        setInterval(function() {
          that.refreshState();
        }, config.REFRESH);
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
